import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import storeConfig from './store/configureStore';

const store = storeConfig();
const root = ReactDOM.createRoot(document.getElementById('root'));

const startApp = () => {
  root.render(
    <Provider store={store}>
      <App />
    </Provider>
  );
}

if(!window.isMobileApp()) {
  startApp()
} else {
  document.addEventListener('deviceready', startApp, false)
}
